export const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

export const CPU_CORES = 1;//navigator.hardwareConcurrency || 3;